import TagType from '@/shared/constants/TagType';
import Tag from '@/shared/models/Tag';

export default class Indicator extends Tag {
  isActive = false;
  isFixedTimeslot = false;
  isCompetence = false;
  dailyCapacity = 0;

  constructor() {
    super();
    this.type = TagType.PLANNING;
  }
}
